export default "__VITE_ASSET__DSTA9Ybp__"